import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Checkbox, Form, Input } from 'antd';

import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';

import styles from '../../styles/auth.module.scss';

import { AuthTitle } from '../../components';
import { useRegisterMutation } from '../../store/api/auth';
import { register } from '../../store/slices/auth';
import { ApiFieldError } from '../../types';

const SignUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [read, toggleRead] = useState(false);
  const [form] = Form.useForm();

  const [registerUser, { isSuccess, isError, error }] = useRegisterMutation();

  const onSubmit = () => {
    const username = form.getFieldValue('signUpEmail');
    const userFirstName = form.getFieldValue('signUpFirstName');
    const userLastName = form.getFieldValue('signUpLastName');
    if (!username || !userFirstName || !userLastName) return null;
    dispatch(register({ username }));
    registerUser({ username, firstName: userFirstName, lastName: userLastName });
  };

  useEffect(() => {
    if (isSuccess) {
      navigate('/reset-password');
      // navigate('confirm');
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (isError) {
      const username = form.getFieldValue('signUpEmail');
      const [{ code }] = error as ApiFieldError[];

      const errorMessage = code === 'unique' ? t('login.alreadyRegistered') : t('common.smthWrong');

      form.setFields([{ name: 'signUpEmail', value: username, errors: [errorMessage] }]);
    }
  }, [isError, error, form, t]);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.form}>
          <AuthTitle title={t('login.titleSignUp')} withBackButtonOnlyMobile={true} />
          <p className={styles.descriptionSignup} dangerouslySetInnerHTML={{ __html: t('login.textSignUp') }}></p>
          <Form
            form={form}
            initialValues={{ signUpEmail: '', signUpFirstName: null, signUpLastName: '' }}
            requiredMark={false}
            autoComplete="off"
          >
            <Form.Item
              name="signUpFirstName"
              rules={[{ required: true, message: t('forms.validation.enterFirstName') }]}
            >
              <Input placeholder={t('labels.firstName')} size={'large'} />
            </Form.Item>
            <Form.Item name="signUpLastName" rules={[{ required: true, message: t('forms.validation.enterLastName') }]}>
              <Input placeholder={t('labels.lastName')} size={'large'} />
            </Form.Item>
            <Form.Item
              name="signUpEmail"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('forms.validation.emailInvalid'),
                },
              ]}
            >
              <Input prefix={<CroplerIcon name="email" />} placeholder="Email" size={'large'} />
            </Form.Item>
            <div className={styles.checkboxContainer}>
              <Checkbox checked={read} onChange={() => toggleRead(!read)} />
              <span className={styles.checkboxDescription}>
                <Trans
                  i18nKey="login.privacyText"
                  components={{
                    link1: (
                      <a
                        href="https://www.cropler.io/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.checkboxLink}
                      >
                        link
                      </a>
                    ),
                    link2: (
                      <a
                        href="https://www.cropler.io/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.checkboxLink}
                      >
                        link
                      </a>
                    ),
                  }}
                />
              </span>
            </div>
            <Button
              type="primary"
              htmlType="submit"
              onClick={onSubmit}
              className={styles.buttonSubmit}
              size={'large'}
              disabled={!read}
            >
              {t('actions.send')}
            </Button>
          </Form>
        </div>
      </div>
      <div className={styles.authFooter}>
        <span>{t('login.joined')}</span>
        <Link to="/login" className={styles.link}>
          {t('actions.login')}
        </Link>
      </div>
    </>
  );
};

export default SignUp;
